:host{
  /* Size */

  --width: var(--jb-notification-width, fit-content);
  --max-width: var(--jb-notification-max-width, calc(100vw - 2rem));
  --border-radius: var(--jb-notification-border-radius, 2.0rem);
  --padding: var(--jb-notification-padding, 0.5rem);
  --gap: var(--jb-notification-gap, 0.25rem);
  --text-gap: var(--jb-notification-text-gap, 0);
  --icon-size: var(--jb-notification-icon-size, 3rem);
  --title-font-weight: var(--jb-notification-title-font-weight, 700);
  --title-font-size: var(--jb-notification-title-font-size, 1.1rem);
  --desc-font-weight: var(--jb-notification-desc-font-weight, 100);
  --desc-font-size: var(--jb-notification-desc-font-size, 0.8rem);

  /* Theme/Color */
  --bg-color-success:var(--jb-notification-bg-color-success, var(--jb-green));
  --bg-color-info:var(--jb-notification-bg-color-info, var(--jb-primary));
  --bg-color-warning:var(--jb-notification-bg-color-warning, var(--jb-yellow));
  --bg-color-error:var(--jb-notification-bg-color-error, var(--jb-red));
  --text-color: var(--jb-text-contrast);
  --text-color-info: var(--jb-notification-text-color-info, var(--text-color));
  --text-color-success: var(--jb-notification-text-color-success, var(--text-color));
  --text-color-warning: var(--jb-notification-text-color-warning, var(--text-color));
  --text-color-error: var(--jb-notification-text-color-error, var(--text-color));
  --icon-bg-color: var(--jb-notification-icon-bg-color, var(--jb-white, #ffffff));
  --icon-symbol-color-success: var(--jb-notification-icon-symbol-color-success, var(--bg-color-success));
  --icon-symbol-color-info: var(--jb-notification-icon-symbol-color-info, var(--bg-color-info));
  --icon-symbol-color-warning: var(--jb-notification-icon-symbol-color-warning, var(--bg-color-warning));
  --icon-symbol-color-error: var(--jb-notification-icon-symbol-color-error, var(--bg-color-error));
  --border-color: var(--jb-notification-border-color, transparent);
  --box-shadow: var(--jb-notification-box-shadow, none);

  /* Other */
  --border-width: var(--jb-notification-border-width, 0);
  --border-style: var(--jb-notification-border-style, solid);
  --grid-template-columns: var(--jb-notification-grid-template-columns, var(--icon-size) minmax(0, 1fr));
  --content-align-items: var(--jb-notification-content-align-items, center);
}
